import React, { Component } from "react";
import { Button, Modal } from "semantic-ui-react";
import Select from "components/Form/Select";
import { Field, Formik, Form } from "formik";
import * as Yup from "yup";
import { connect } from "react-redux";

const schemaValidation = Yup.object().shape({
	untaken_reason: Yup.string().required("Champ requis"),
});

class TubeUntakenModal extends Component {
	render() {
		const { open, tubeReasons, close, submit } = this.props;

		return (
			<Modal size="small" open={open} closeOnEscape closeOnDimmerClick onClose={close}>
				<Modal.Header>Tube non prélevé</Modal.Header>
				<Formik
					enableReinitialize
					initialValues={{
						untaken_reason: "",
					}}
					validationSchema={schemaValidation}
					onSubmit={(values) => {
						submit(values.untaken_reason);
					}}
				>
					{({ submitForm }) => (
						<>
							<Modal.Content>
								<Form>
									<Field
										component={Select}
										name="untaken_reason"
										customlabel="Motif"
										options={tubeReasons.untaken.map((reason) => ({
											value: reason.label,
											label: reason.label,
										}))}
										isCreatable
										required
									/>
								</Form>
							</Modal.Content>

							<Modal.Actions>
								<Button
									onClick={(e) => {
										if (e !== undefined) e.preventDefault();
										close();
									}}
								>
									Annuler
								</Button>
								<Button
									primary
									onClick={(e) => {
										if (e !== undefined) e.preventDefault();
										submitForm();
									}}
								>
									Confirmer
								</Button>
							</Modal.Actions>
						</>
					)}
				</Formik>
			</Modal>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		tubeReasons: state.tubeReasons,
	};
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(TubeUntakenModal);
